import { CustomState } from "../CustomState";
import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { ClienteDTO, CodigoDTO } from "@DTOS";
import { CodigosService } from "@shared/servicesBackend";
import { CodigosAcciones } from "./codigos.acciones";
import { Nilable } from "@shared/utils";
import { ClientesAcciones } from "@shared/states";

export interface CodigoStateModel {
    codigos: CodigoDTO[];
}

@State<CodigoStateModel>({
    name: "codigos",
    defaults: {
        codigos: []
    }
})
@Injectable()
export class CodigosState extends CustomState<CodigoStateModel> {
    private codigos: Nilable<CodigoDTO[]>;

    constructor(private codigosService: CodigosService) {
        super();
    }

    @Action(CodigosAcciones.ObtenerCodigos)
    public async obtenerCodigos(ctx: StateContext<CodigoStateModel>) {
        const stateNuevo = this.obtenerNuevoState(ctx);
        if (this.codigos == null) {
            this.codigos = await this.codigosService.obtenerCodigos();
            ctx.dispatch(new ClientesAcciones.PedirEntidades(CodigosAcciones.CargarClientes));
        }
        stateNuevo.codigos = [...this.codigos];
        ctx.setState(stateNuevo);
    }

    @Action(CodigosAcciones.AgregarCodigo)
    public async agregarCodigo(ctx: StateContext<CodigoStateModel>, action: CodigosAcciones.AgregarCodigo) {
        const stateNuevo = this.obtenerNuevoState(ctx);
        const codigo = await this.codigosService.agregarCodigo(action.codigoValor, action.cliente);
        if (this.codigos == null) {
            this.codigos = [];
        }
        this.codigos.push(codigo);
        ctx.dispatch(new ClientesAcciones.PedirEntidades(CodigosAcciones.CargarClientes));
        stateNuevo.codigos = [...this.codigos];
        ctx.setState(stateNuevo);
    }

    @Action(CodigosAcciones.CargarClientes)
    public cargarClientes(ctx: StateContext<CodigoStateModel>, action: CodigosAcciones.CargarClientes) {
        const nuevoState = this.obtenerNuevoState(ctx);

        if (this.codigos != null) {
            this.codigos = this.codigos.map(codigo => {
                const clone = new CodigoDTO(codigo.toJSON());
                clone.cliente = action.clientes.find(cliente => cliente.id === codigo.cliente.id) ??
                    new ClienteDTO({ id: codigo.cliente.id });
                return clone;
            });
            nuevoState.codigos = [...this.codigos];
        }

        ctx.setState(nuevoState);
    }
}
